/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/24/2022
 *
 */

import React from 'react';
import Loader from "../../../loader/loader";
import FormElementGenerator from "../../form-elements/formElementGenerator";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import axios from "axios";
import API from "../../../../../utils/api";

class AuditDataDisplayForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tpiAuditId: null,
            tpiAuditAction: '',
            tpiAuditController: '',
            tpiAuditEmail: '',
            tpiAuditParam: '',
            tpiAuditCreatedDate: '',

            isDisplayLoader: true,
            errors: {},

            token: '',
            fields: [
                {
                    inputType: 'text',
                    labelName: 'Action',
                    inputName: 'tpiAuditAction',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Controller',
                    inputName: 'tpiAuditController',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Email',
                    inputName: 'tpiAuditEmail',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'textUrl',
                    labelName: 'Params',
                    inputName: 'tpiAuditParam',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Date Created',
                    inputName: 'tpiAuditCreatedDate',
                    placeholder: '',
                    value: '',
                    required: false,
                    disabled: true
                }
            ]
        };

        // set icons to the header
        EventEmitter.emit('setPageHeaderData', {
            page: 'audit',
            pageName: "Audit",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/audit",
            optionalIcons: ['backIcon']
        });
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }

    // set a token to unsubscribe the async call
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();

    componentDidMount = async () => {
        // get parameter from URL
        const auditId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create partner
        if (auditId !== undefined) {

            const url = '/audit?search=%7BtpiAuditId:' + auditId + '%7D';

            await API.get(url, {headers: {Authorization: token}, cancelToken: this.source.token})
                .then(res => {
                    const data = res.data[0];
                    oldState.tpiAuditId = (data.tpiAuditId !== undefined) ? data.tpiAuditId : null;
                    oldState.tpiAuditAction = (data.tpiAuditAction !== undefined) ? data.tpiAuditAction : null;
                    oldState.tpiAuditController = (data.tpiAuditController !== undefined) ? data.tpiAuditController : '';
                    oldState.tpiAuditEmail = (data.tpiAuditEmail !== undefined) ? data.tpiAuditEmail : '';
                    oldState.tpiAuditParam = (data.tpiAuditParam !== undefined) ? data.tpiAuditParam : '';
                    oldState.tpiAuditCreatedDate = (data.tpiAuditCreatedDate !== undefined) ? data.tpiAuditCreatedDate : '';

                    oldState.token = token;
                    oldState.isDisplayLoader = false;

                    this.setState(oldState);
                }).catch(er => {
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);

                    if (er.response === undefined) {
                        localStorage.removeItem('tmcUser')
                        this.props.history.push('/');
                    } else {
                        this.setAlert("Error", "Error", "Sorry! Unable to load Audit details");
                    }
                });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        // remove all event emitters
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
        this.source.cancel("cancel audit async calls");
    };

    /**
     * navigate to previous page
     */
    navigateToPreviousPage = () => {
        this.props.history.push('/home/audit');
    };

    handleChange = event => {
        console.log("Do not delete");
    };

    render() {
        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={this.handleChange} />
                </form>
            </div>
        )
    }
}

export default AuditDataDisplayForm;
